import React, { useState, useEffect } from 'react';
import { useSyncStatus } from '../context/SyncStatusContext';
import VideoModal from './VideoModal';

// Shown once per browser session, only while the post-login sync (critical
// or background) is still in progress — keeps the user occupied instead of
// staring at an empty dashboard.
const SESSION_FLAG = 'welcome_video_shown';

const WelcomeVideoOverlay = () => {
  const { syncStatus } = useSyncStatus();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem(SESSION_FLAG)) return;
    if (!syncStatus) return;

    const syncInProgress =
      !syncStatus.critical_completed || ['queued', 'running'].includes(syncStatus.background_status);

    if (syncInProgress) {
      setVisible(true);
    }
  }, [syncStatus]);

  const dismiss = () => {
    sessionStorage.setItem(SESSION_FLAG, '1');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <VideoModal
      src="/videos/Bienvenida.mp4"
      onClose={dismiss}
      caption="Mientras preparamos tus datos, te mostramos cómo sacarle el máximo provecho a MeLi Profit Hub."
    />
  );
};

export default WelcomeVideoOverlay;
